import React from 'react';
import { ATMHeader, ATMTable } from 'shared-it-appmod-ui';
import LabelRequired from 'src/components/atoms/label-required/label-required.component';
import { DEFAULT_EMPLOYEE_NUMBER, PassengerType } from 'src/constants';
import Lang from 'src/libraries/language';
import { IRequestPassenger } from 'src/models/request.model';

type IProps = {
  data?: IRequestPassenger[];
};

const FlightRequestPassengerInformation: React.FC<IProps> = ({ data = [] }) => {
  return (
    <>
      <ATMHeader size="small" className="text-underline">
        {Lang.LBL_PASSENGER_INFORMATION}
      </ATMHeader>

      <ATMTable>
        <ATMTable.Header>
          <ATMTable.Row>
            <ATMTable.HeaderCell>{Lang.LBL_PASSENGER_TYPE}</ATMTable.HeaderCell>
            <ATMTable.HeaderCell>
              <LabelRequired>{Lang.LBL_PASSENGER_NAME}</LabelRequired>
            </ATMTable.HeaderCell>
            <ATMTable.HeaderCell>
              <LabelRequired>{Lang.LBL_WEIGHT}</LabelRequired>
            </ATMTable.HeaderCell>
            <ATMTable.HeaderCell />
          </ATMTable.Row>
        </ATMTable.Header>

        <ATMTable.Body>
          {data.map((value, key) => (
            <ATMTable.Row key={`passenger_${key}`}>
              <ATMTable.Cell>
                {value.empNo !== DEFAULT_EMPLOYEE_NUMBER
                  ? PassengerType.Employee
                  : PassengerType.Contractor}
              </ATMTable.Cell>
              <ATMTable.Cell>{value.name}</ATMTable.Cell>
              <ATMTable.Cell>
                {Lang.formatString(
                  Lang.LBL_POUNDS,
                  (value?.weight ?? 0).toString()
                )}
              </ATMTable.Cell>
            </ATMTable.Row>
          ))}
        </ATMTable.Body>
      </ATMTable>
    </>
  );
};

export default FlightRequestPassengerInformation;
